<template>
  <div>
    <!-- Mobile Top Bar -->
    <div
      v-if="isMobile"
      class="d-flex align-items-center px-3 py-2 bg-light shadow-sm sticky-top"
    >
      <b-button variant="link" class="p-0 mr-2" @click="drawerOpen = true">
        <b-icon-list></b-icon-list>
      </b-button>
      <span class="font-weight-bold">{{ activePageTitle }}</span>
    </div>

    <!-- Mobile Drawer -->
    <b-sidebar
      id="products-drawer"
      title="Products Menu"
      bg-variant="light"
      text-variant="dark"
      shadow
      backdrop
      placement="left"
      :visible="drawerOpen"
      @hidden="drawerOpen = false"
    >
      <hr />
      <ul class="list-unstyled m-0">
        <li v-for="(page, index) in filteredPages" :key="index" class="mb-2">
          <b-button
            block
            squared
            :variant="activePageIndex === index ? null : 'link'"
            class="text-left"
            @click="selectPage(index)"
          >
            <b-icon :icon="page.icon" class="mr-2"></b-icon>
            {{ page.title }}
          </b-button>
        </li>
      </ul>
    </b-sidebar>

    <!-- Desktop Tabs -->
    <div v-if="!isMobile">
      <b-tabs card lazy v-model="activePageIndex">
        <b-tab
          v-for="(page, index) in filteredPages"
          :key="index"
          :title="page.title"
        >
          <keep-alive>
            <component :is="page.component"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>

    <!-- Mobile Content -->
    <div v-if="isMobile" class="mt-2">
      <keep-alive>
        <component v-if="activePageComponent" :is="activePageComponent"></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import {
  BIconList,
  BIconBox,
  BIconClipboard,
  BIconArchive,
  BIconFileText,
  BIconGear,
  BIconTag
} from "bootstrap-vue";

// Main page components
import AllProductsPage from "@/components/Products/AllProductsPage";
import ProductManagerPage from "@/components/Products/ProductManagerPage";
import ManageSalePage from "@/components/Products/ManageSalePage";
import ProductsSellingHistory from "@/components/Products/ProductsSellingHistory";
import LowInventory from "@/components/Products/LowInventory";

export default {
  name: "ProductsMain",
  components: {
    AllProductsPage,
    ProductManagerPage,
    ManageSalePage,
    ProductsSellingHistory,
    LowInventory,
    BIconList,
    BIconBox,
    BIconClipboard,
    BIconArchive,
    BIconFileText,
    BIconGear,
    BIconTag
  },
  data() {
    return {
      drawerOpen: false,
      activePageIndex: 0,
      isMobile: false,
      packet: { userDetails: {} },

      pages: [
        {
          title: "ALL PRODUCTS",
          icon: "box",
          roles: [
            "admin","accountmanager","officeuser","officemanager",
            "locationadmin","locationstockperson","salesperson",
            "warehouseuser","warehousemanager","accountuser"
          ],
          component: "AllProductsPage"
        },
        {
          title: "PRODUCT MANAGER",
          icon: "gear",
          roles: ["admin"],
          component: "ProductManagerPage"
        },
        {
          title: "MANAGE SALE",
          icon: "tag",
          roles: ["admin"],
          component: "ManageSalePage"
        },
        {
          title: "ITEM HISTORY",
          icon: "clipboard",
          roles: [
            "admin","accountmanager","officeuser","officemanager",
            "locationadmin","locationstockperson","salesperson",
            "warehouseuser","warehousemanager","accountuser"
          ],
          component: "ProductsSellingHistory"
        },
        {
          title: "LOW INVENTORY",
          icon: "exclamation-triangle",
          roles: [
            "admin","accountmanager","officeuser","officemanager",
            "locationadmin","locationstockperson","warehousemanager"
          ],
          component: "LowInventory"
        }
      ]
    };
  },
  computed: {
    filteredPages() {
      const role = this.packet.userDetails.userrole || "";
      return this.pages.filter(p => p.roles.includes(role));
    },
    activePageTitle() {
      const p = this.filteredPages[this.activePageIndex];
      return p ? p.title : "Menu";
    },
    activePageComponent() {
      const p = this.filteredPages[this.activePageIndex];
      return p ? p.component : null;
    }
  },
  methods: {
    selectPage(index) {
      this.activePageIndex = index;
      this.drawerOpen = false;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    loadUser() {
      try {
        this.packet = JSON.parse(localStorage.packet || "{}");
        this.packet.userDetails = JSON.parse(localStorage.userDetails || "{}");
      } catch (err) {
        console.error("Error parsing user data:", err);
      }
    }
  },
  created() {
    this.loadUser();
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
@media (max-width: 767px) {
  .b-tabs { display: none; }
}
</style>


// WEBPACK FOOTER //
// src/components/Products/ProductsMain.vue